import dayjs from 'dayjs';
import store from '../redux/store';
import utc from 'dayjs/plugin/utc';
import { CartItem } from '../types/cart';
import { cloneDeep } from 'lodash-es';
import { RefreshCartItemsValidityPayload } from '../types/cart-state';
import { resetSiteLevelDate } from '../redux/slice/cartSlice';

dayjs.extend(utc);

export const checkInvalidStartDate = (startDate: number) => {
  const cart = store.getState().cart;

  const timezone = cart.timezone;

  const minStartDate = dayjs().utc().add(1, 'day').startOf('day').tz(timezone);

  const timestampInTimezone = dayjs.unix(startDate).utc().tz(timezone);

  return timestampInTimezone.isBefore(minStartDate, 'date');
};

export const getCartItemsValidityPayload = () => {
  const cart = cloneDeep(store.getState().cart);

  let valid = true;

  const items: CartItem[] = cart.cartItems.map((item) => {
    item.isStartDateValid = !checkInvalidStartDate(item.startDate);
    if (item.isStartDateValid === false) valid = false;
    return item;
  });

  const areCartItemsValid: boolean = valid;

  const payload: RefreshCartItemsValidityPayload = {
    items,
    areCartItemsValid,
  };

  return payload;
};

export const initSiteLevelDate = () => {
  const siteLevelDate = store.getState().cart.siteLevelDate;
  const cartLength = store.getState().cart.cartItems.length;
  if (siteLevelDate && cartLength) {
    const today = dayjs().startOf('day');
    const updatedOnDate = dayjs.unix(siteLevelDate.updatedOn);
    const isSameDay = updatedOnDate.isSame(today, 'day');

    if (!isSameDay) {
      store.dispatch(resetSiteLevelDate());
    }
  }
};
